/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Descriptor, { IDescriptorBody } from './../../descriptor';

interface ICommonSuggestion {
	id: string;
	authorId: string;
	type: string;
	hasComments?: boolean;
	state?: string;
}

export interface ISuggestion extends ICommonSuggestion {
	createdAt?: Date;
	data?: Record<string, unknown> | null;
	attributes?: Record<string, unknown> | null;
}

export interface ISuggestionJSON extends ICommonSuggestion {
	createdAt?: string;
	data?: string | null;
	attributes?: string | null;
}

export default class SuggestionDescriptor extends Descriptor {
	public static readonly DESCRIPTOR_NAME: string = 'SuggestionDescriptor';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				id: 1,
				type: 'string'
			},
			authorId: {
				id: 2,
				type: 'string'
			},
			type: {
				id: 3,
				type: 'string'
			},
			createdAt: {
				id: 4,
				type: 'string'
			},
			data: {
				id: 5,
				type: 'string'
			},
			hasComments: {
				id: 6,
				type: 'bool'
			},
			state: {
				id: 7,
				type: 'string'
			},
			attributes: {
				id: 8,
				type: 'string'
			}
		}
	};

	public static toJSON( suggestion: ISuggestion ): ISuggestionJSON {
		return {
			...suggestion,
			data: suggestion.data ? JSON.stringify( suggestion.data ) : suggestion.data,
			attributes: suggestion.attributes ? JSON.stringify( suggestion.attributes ) : suggestion.attributes,
			createdAt: suggestion.createdAt?.toISOString()
		};
	}

	public static fromJSON( suggestion: ISuggestionJSON ): ISuggestion {
		return {
			...suggestion,
			data: suggestion.data ? JSON.parse( suggestion.data ) : suggestion.data,
			attributes: suggestion.attributes ? JSON.parse( suggestion.attributes ) : suggestion.attributes,
			createdAt: suggestion.createdAt ? new Date( suggestion.createdAt ) : undefined
		};
	}
}
